import { select, addClass, removeClass, on } from 'helpers/dom'

const selectors = {
  SHOW_PASSWORD_SELECTOR: '.js-show-password',
  IS_SHOW_PASSWORD_CLASS: 'is-show-password',
  INPUT_TAG: 'input',
  NOTICE_ERROR_SELECTOR: 'p.input-error',
  HIDDEN_CLASS: 'hidden',
  IS_INVALID_CLASS: 'is-invalid'
}

class CustomInputPassword extends HTMLElement {
  constructor() {
    super()

    this.buttonShowEl = select(selectors.SHOW_PASSWORD_SELECTOR, this)
    this.inputEl = select(selectors.INPUT_TAG, this)
    this.noticeEl = select(selectors.NOTICE_ERROR_SELECTOR)
  }

  connectedCallback() {
    this.attackEvent()

    if (this.noticeEl) {
      this.removeErrorForm()
    }
  }

  attackEvent() {
    if (this.buttonShowEl) {
      this.buttonShowEl.addEventListener('click', () => {
        if (this.inputEl.type === 'password') {
          this.inputEl.type = 'text'
          addClass(selectors.IS_SHOW_PASSWORD_CLASS, this.buttonShowEl)
        } else {
          this.inputEl.type = 'password'
          removeClass(selectors.IS_SHOW_PASSWORD_CLASS, this.buttonShowEl)
        }
      })
    }
  }

  removeErrorForm() {
    this.inputEl.addEventListener('focus', () => {
      if (this.inputEl.classList.contains(selectors.IS_INVALID_CLASS) && (this.noticeEl.classList.contains(selectors.HIDDEN_CLASS) === false)) {
        removeClass(selectors.IS_INVALID_CLASS, this.inputEl)
      }
      addClass(selectors.HIDDEN_CLASS, this.noticeEl)
    })
  }
}

customElements.define('custom-input-password', CustomInputPassword)
